<template>
  <section class="row">
    <div class="col-sm-12">
      <div v-cloak v-if="loaded && !addresses.length" class="col-sm-12 text-center">
        <div class="big-message">I'm Empty !!!</div>
        <p class="help-block">Click "add new address" below.</p>
      </div>
      <div
        v-for="address in addresses"
        :key="address.accountaddressID"
        class="address-item"
        @click.stop.prevent="$store.dispatch('editAddress', address)">
        <div>
          <a class="remove-item" href="#" @click.stop.prevent="removeAddress(address)">
            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
          </a>
          <address-item class="pull-left" :address="address"/>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <btn type="primary" class="btn-sm btn-text pull-right" @click.prevent.stop="addAddress">Add New Address</btn>
    </div>
    <address-modal @save="onSave"/>
  </section>
</template>

<style scoped>
.address-item:hover {
  background-color: #d9d9d9;
}
</style>

<script>
import axios from 'axios'
import { jrNotifyEx } from '../../bootstrap'
import AddressItem from './AddressItem'
import AddressModal from './AddressModal'
import { MessageBox, Btn } from 'uiv'

export default {
    components: {
        'address-item': AddressItem,
        'address-modal': AddressModal,
        'btn': Btn,
    },

    props: {
        initialAddresses: {
            type: Object,
            default: null,
        },
    },

    data () {
        return {
            loaded: false,
            addresses: [],
        }
    },

    async created () {
        if (this.initialAddresses && this.initialAddresses.data) {
            this.addresses = this.initialAddresses.data
            this.loaded = true
        } else {
            this.fetchAddressList()
        }
    },

    methods: {
        fetchAddressList: async function() {
            try {
                const response = await axios.get("/account-address")
                this.addresses = response.data.data
                this.loaded = true
            } catch (e) {
                jrNotifyEx(e)
            }
        },

        addAddress: function() {
            this.$store.dispatch('editAddress', {
                accountaddressID: null,
                countryID: 1,
                firstname: null,
                lastname: null,
                company: null,
                daytimephone: null,
                address1: null,
                address2: null,
                address3: null,
                city: null,
                stateID: null,
                province: null,
                zip: null,
            })
        },

        removeAddress: function(address) {
            MessageBox.confirm({
                title: 'Remove Address',
                content: 'Remove this address from you account?'
            }).then(async () => {
                try {
                    const response = await axios.post("/account-address/remove", {
                        accountaddressID: address.accountaddressID
                    })
                    this.addresses = response.data.data
                } catch (e) {
                    jrNotifyEx(e)
                }
            }).catch(() => {})
        },

        onSave: function(data) {
            this.addresses = data.data
        },
    }
}
</script>
